var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m6 0 1.9 3.758 4.1.727-2.706 3.006L9.835 12 6 9.77 2.118 12l.706-4.509L0 4.485l4.134-.727z"
})));
export default SvgIconStar;